export const TimelineAction = {
  Added: 1,
  Updated: 2,
  Deleted: 3,
  Imported: 4,
  Emailed: 5,
  Deactivated: 6,
  Activated: 7,
  Script: 8,
  PhoneCall: 9,
  Dismissed: 10,
  Opened: 11,
  Closed: 12,
  Merged: 13,
  Verified: 14,
  Purchase: 25,
};

export const TimelineType = {
  FollowUpDismissed: 1,
  FollowUpDeleted: 2,
  FollowUpAdded: 3,
  FollowUpPhoneCall: 4,
  CustomerVerifyAddress: 5,
  SystemAnalysisUpdated: 6,
  SystemAnalysisAdded: 7,
  SystemAnalysisDeleted: 8,
  AccountNoteAdded: 9,
  AccountNoteDeleted: 10,
  AccountNoteUpdated: 11,
  AccountAdded: 12,
  AccountUpdated: 13,
  AccountDeleted: 14,
  SystemNoteAdded: 15,
  SystemNoteDeleted: 16,
  SystemNoteUpdated: 17,
  ContactAdded: 18,
  ContactDeleted: 19,
  ContactUpdated: 20,
  SystemAdded: 21,
  SystemDeleted: 22,
  SystemUpdated: 23,
  SystemMerge: 24,
  ReportHistoryEmail: 25,
  SeasonUsageEmail: 26,
  AnalysisEmail: 27,
  SaveEmailPreferences: 28,
  AccountMergeInto: 29,
  CustomerMergeDeleted: 30,
  AnalysisImported: 31,
  CustomerImported: 32,
  SystemImported: 33,
  PastDueCustomerEmailed: 34,
  FollowUpEmailed: 35,
  WinterProductReminderEmailed: 36,
  InactiveCustomerEmailed: 37,
  WinterClosingEmailed: 38,
  DirectEmail: 39,
  EncyclopediaEmail: 40,
  CustomerAddedAlexProScript: 41,
  CustomerAddedAlexDesktopScript: 42,
  CustomerImportedScript: 43,
  CustomerNoteScript: 44,
  CustomerContactScript: 45,
  SystemAddedAlexProScript: 46,
  SystemAddedAlexDesktopScript: 47,
  SystemImportedScript: 48,
  SystemNoteScript: 49,
  FollowUpAddedAlexProScript: 50,
  FollowUpAddedAlexDesktopScript: 51,
  FollowUpImportedScript: 52,
  AnalysisAddedAlexProScript: 53,
  AnalysisAddedAlexDesktopScript: 54,
  AnalysisImportedScript: 55,
  WelcomeEmail: 56,
  BecameTruBlu: 57,
  RemovedTruBlu: 58,
  AccountDeactivated: 59,
  AccountActivated: 60,
  PoolOpened: 61,
  PoolClosed: 62,
  SourceWaterTested: 63,
  SourceWaterUpdated: 64,
  SourceConcern: 65,
  SeasonUsageUpdated: 66,
  AccountEmailPref: 67,
  AccountStarred: 68,
  Product: 69,
  AnalysisNoteAdded: 70,
  AnalysisNoteUpdated: 71,
  Anniversary: 72, //front end only this type can change #
};
